// Shared shape + validity helpers for the realtime retention parameter builder,
// used by Realtime.vue (JSON emission) and RealtimeRuleCard.vue (per-card state)
// so both judge a rule "complete" identically.

let uid = 0;
export const makeRule = (partial = {}) => ({
  key: ++uid,
  productId: null,
  mode: 'REGULAR',
  targetProductId: null,
  offerIdentifier: null,
  message: { localized: false, single: null, entries: [] },
  ...partial
});

// The message identifier is the Firestore doc id and the Apple token at once
// (config-manager sets all three to one uuid), so any mode emits the same value.
export const identifierOf = (msg) => (msg ? msg.messageIdentifier || msg.id || null : null);

export const messageIdentifierValue = (message) => {
  if (!message) return null;
  if (!message.localized) return identifierOf(message.single);
  const obj = {};
  for (const e of message.entries) {
    if (e.locale && e.message) obj[e.locale] = identifierOf(e.message);
  }
  return Object.keys(obj).length ? obj : null;
};

// Mode-specific field requirements, shared by full rules and the bulk-add draft.
export const modeFieldsValid = (rule) => {
  if (rule.mode !== 'REGULAR' && !rule.targetProductId) return false;
  if (rule.mode === 'SWITCH_PLAN' && rule.targetProductId === rule.productId) return false;
  if (rule.mode === 'PROMOTIONAL_OFFER' && !rule.offerIdentifier) return false;
  return true;
};

export const ruleComplete = (rule) =>
  !!(rule.productId && messageIdentifierValue(rule.message) && modeFieldsValid(rule));
